export default "__VITE_ASSET__Doc4QSWt__"